const LK_Search =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" fill={color} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
            {/* <defs>
            <style>
                .cls-1 {
                fill: #005c8e;
                stroke-width: 0px;
                }
            </style>
            </defs> */}
            <path class="cls-1" d="M71.49,2.99c-25.13,0-45.49,20.37-45.49,45.49,0,7.54,1.85,14.64,5.09,20.91L0,100.48l9.29,9.29c2.82,2.82,6.52,4.23,10.21,4.23s7.39-1.41,10.21-4.23l20.88-20.88c6.26,3.25,13.37,5.09,20.91,5.09,25.13,0,45.49-20.37,45.49-45.49S96.62,2.99,71.49,2.99ZM26.17,106.23c-1.78,1.78-4.15,2.76-6.67,2.76s-4.89-.98-6.67-2.76l-5.75-5.75,26.64-26.64c3.3,4.9,7.52,9.13,12.42,12.42l-19.96,19.96ZM71.49,88.98c-6.13,0-11.95-1.38-17.16-3.83-1.58-.74-3.1-1.59-4.56-2.52-4.99-3.19-9.24-7.43-12.42-12.42-.93-1.46-1.78-2.98-2.52-4.56-2.45-5.22-3.83-11.03-3.83-17.16,0-22.33,18.16-40.49,40.49-40.49s40.49,18.16,40.49,40.49-18.16,40.49-40.49,40.49Z"/>
        </svg>
    );
};

export default LK_Search;